module.exports = __webpack_public_path__ + "img/core-event-blue.cf202682.png";